import { render, staticRenderFns } from "./adulticide_details.vue?vue&type=template&id=07ee81b2&"
import script from "./adulticide_details.vue?vue&type=script&lang=js&"
export * from "./adulticide_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports